import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../utils/api';

const Schema = () => {
  const [schemas, setSchemas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch active schemas from public API
    const API_URL = API_BASE_URL;
    
    fetch(`${API_URL}/schema/public`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch schemas');
        }
        return response.json();
      })
      .then(data => {
        setSchemas(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading schemas:', error);
        setError('Failed to load schemas');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div style={{ 
        padding: '40px', 
        textAlign: 'center',
        fontFamily: 'monospace',
        backgroundColor: '#1e1e1e',
        color: '#d4d4d4',
        minHeight: '100vh'
      }}>
        <pre style={{ margin: 0, fontSize: '14px' }}>Loading schemas...</pre>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        padding: '40px', 
        textAlign: 'center',
        fontFamily: 'monospace',
        backgroundColor: '#1e1e1e',
        color: '#f48771',
        minHeight: '100vh'
      }}>
        <pre style={{ margin: 0, fontSize: '14px' }}>Error: {error}</pre>
      </div>
    );
  }

  if (schemas.length === 0) {
    return (
      <div style={{ 
        padding: '40px', 
        textAlign: 'center',
        fontFamily: 'monospace',
        backgroundColor: '#1e1e1e',
        color: '#d4d4d4',
        minHeight: '100vh'
      }}>
        <pre style={{ margin: 0, fontSize: '14px' }}>No active schemas found.</pre>
      </div>
    );
  }

  // Combine all schemas into a single JSON array or object
  const allSchemasJson = schemas.length === 1 
    ? JSON.stringify(schemas[0].schema_data, null, 2)
    : JSON.stringify(schemas.map(s => s.schema_data), null, 2);

  return (
    <div style={{ 
      fontFamily: 'monospace',
      padding: '0',
      margin: '0',
      backgroundColor: '#1e1e1e',
      color: '#d4d4d4',
      minHeight: '100vh',
      overflow: 'auto'
    }}>
      <pre style={{
        margin: '0',
        padding: '20px',
        fontSize: '14px',
        lineHeight: '1.6',
        whiteSpace: 'pre',
        wordWrap: 'normal',
        overflowX: 'auto',
        fontFamily: '"Fira Code", "Consolas", "Monaco", "Courier New", monospace'
      }}>
        {allSchemasJson}
      </pre>
    </div>
  );
};

export default Schema;

